import React from "react";
import AllLocation from "../components/AllLocation";

export default function Locations() {
  return (
    <div>
      <AllLocation />
    </div>
  );
}
